module.exports = __webpack_public_path__ + "static/media/stonybrook.a3de9938.png";